import Image from "next/image";
import styles from './ProductTile.module.css';
import { ElemenetType, WishlistType } from '../../lib/constants';
import { useGlobalContext } from '../../lib/context';
import { IProduct } from '../../interfaces';
import { LeadPopUpButton } from '../shared/lead/LeadPopUpButton';
import { imageLoaderfitCrop } from "../../lib/helpers/imageLoader";
import { pushRoute } from "@/lib/helpers/common";
import { WishlistIcon } from "../shared/wishlistIcon";
import { NavLink } from "../ui";

type props = {
    product: IProduct,
    index: number,
    isScrollTileWith?: boolean,
}

export function ProductTile({ product, index, isScrollTileWith }: props) {
    const { props: { countryCode, isMobileView } } = useGlobalContext();
    const siteURL = process.env.SITE_URL + "/" + countryCode;
    const isNewDiProducts = product?.productSlug?.includes('-pid-') || false;
    return (
        <div className={isScrollTileWith && isMobileView ? `${styles.productTile} ${styles.tileMobWith}` : styles.productTile}>
            <div onClick={() => pushRoute(`${siteURL}/interior-design-ideas/${product.categorySlug}/${product.productSlug}`)}>
                <figure>
                    <Image
                        loader={imageLoaderfitCrop}
                        loading={(isMobileView ? index === 0 : index <= 2) ? "eager" : "lazy"}
                        src={product.relativePath}
                        height={300}
                        width={368}
                        quality={85}
                        className="img-responsive"
                        alt={product.title}
                        title={product.title}
                    />
                </figure>
                <div className={styles.tileDescNew}>
                    <div className={styles.producctTileDesc}>
                        {
                            !isNewDiProducts ? 
                            <h2 className={`${styles.tileTxt} font16 text222 f600 lineHeight20`}>{product.title}</h2>:
                            <NavLink href={`${siteURL}/interior-design-ideas/${product.categorySlug}/${product.productSlug}`}><h2 className={`${styles.tileTxt} font16 text222 f600 lineHeight20`}>{product.title}</h2></NavLink>
                        }
                    </div>
                    {/* <p className={`${styles.tileNewTxt} font14 text666 lineHeight20`}>{product.description}</p> */}
                </div>
            </div>
            <WishlistIcon key={index} WishlistType={WishlistType.DESIGN_IDEA} productId={product.productId} />
            <div className={styles.bookLeadBtn}>
                <LeadPopUpButton ElemenetType={ElemenetType.span} ButtonClass={`${styles.getQuoteTxt} primaryBtn `}>Get Quote</LeadPopUpButton>
            </div>
        </div>
    );
}